import { Dispatch } from "redux";
import { Card } from "@fdr-mar/promos-types/Component";
import { CPPService } from "../cpp-service";
import { storeCPPPromotions } from "../redux/actions";

export const storeCPPPromosLocalStorage = (cppPromos: Card[]) => {
  const optedInPromoIDs =
    cppPromos &&
    cppPromos.reduce((optedInIDs: string[], promo: Card) => {
      if (promo.isOptedIn) {
        optedInIDs.push(promo.promoId.toString());
      }
      return optedInIDs;
    }, []);

  localStorage.setItem("cppOptedInPromos", JSON.stringify(optedInPromoIDs));
};

export const getAndStoreCPPPromos = (
  dispatch: Dispatch,
  enableCPPPromos?: boolean
) => {
  const cppService = new CPPService();

  if (enableCPPPromos) {
    cppService.getPromos().then((cppPromos: Card[]) => {
      dispatch(storeCPPPromotions(cppPromos || []));

      storeCPPPromosLocalStorage(cppPromos);
    });
  }
};
